module.exports = __webpack_public_path__ + "static/media/contact_background.0642d955.png";